<template>
    <div>
        <div class="content-caption dashed">
            <span>请购方</span>
        </div>
        <el-form :model="deviceRequireVoucher" ref="requireVoucherRef" :rules="checkVoucher">
            <div class="simple-form flex col-2">
                <div class="form-group center" v-if="!isBatchFalg">
                    <div class="form-label">
                        <label class="required">购置部门</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="requireComName">
                            <el-input class="width-1-5x bottom-line" disabled type="text" v-model="deviceRequireVoucher.requireComName"></el-input>
                            <div v-if="id == null" class="form-tips icon iconfont icon-chazhaobiaodanliebiao relation-icon" title="选择" @click="selectRequireCom()"></div>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center" v-if="!isBatchFalg">
                    <div class="form-label">
                        <label class="required">购置公司</label>
                    </div>
                    <div class="form-value">
                        <span>{{ deviceRequireVoucher.requireRealComName || '' }}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label class="">经办人</label>
                    </div>
                    <div class="form-value">
                        <span>{{ deviceRequireVoucher.applicantName }}</span>
                    </div>
                </div>
                <div v-if="isBatchFalg" class="form-group center">
                    <div class="form-label">
                        <label class="required">已外部审核</label>
                    </div>
                    <div class="form-value width-1-5x">
                        <el-radio-group v-model="deviceRequireVoucher.outAuditFlag">
                            <el-radio :label="true">是</el-radio>
                            <el-radio :label="false">否</el-radio>
                        </el-radio-group>
                    </div>
                </div>
                <div v-if="isBatchFalg" class="form-group center">
                    <div class="form-label">
                        <label :class="deviceRequireVoucher.outAuditFlag? 'required': ''">审核单号</label>
                    </div>
                    <div class="form-value width-1-5x">
                        <el-form-item prop="auditPoofNo">
                            <el-input type="text" v-model="deviceRequireVoucher.auditPoofNo"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">单独采购组装件</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-form-item prop="onlyForAsmblAcc">
                            <el-switch v-model="deviceRequireVoucher.onlyForAsmblAcc" active-color="#13ce66"></el-switch>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">标题</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-form-item prop="title">
                            <el-input type="text" placeholder="例如：XXX店（店号+店名）申请购置XX类设备" v-model="deviceRequireVoucher.title"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">采购需求</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="desc">
                            <el-input class="textarea-value" placeholder="请填写设备投入产出分析说明、资产购置描述和资产描述" type="textarea" :rows="3" v-model="deviceRequireVoucher.desc" resize="both"></el-input>
                        </el-form-item>
                    </div>
                </div>
            </div>
            <template v-if="isBatchFalg">
                <swb-create-require-item-for-batch :id="id" :reloadItem="reloadItem" :onlyForAsmblAcc="deviceRequireVoucher.onlyForAsmblAcc"
                                                   :audoAuditorFlag="deviceRequireVoucher.audoAuditorFlag" :lowCostFlag="lowCostFlag" ref="swb_create_require_item_for_batch"></swb-create-require-item-for-batch>
            </template>
            <template v-else>
                <swb-create-require-item :id="id" :reloadItem="reloadItem" :requireRealComId="deviceRequireVoucher.requireRealComId" :onlyForAsmblAcc="deviceRequireVoucher.onlyForAsmblAcc"
                                         :bizFormId="bizFormId" :bizAreaId="bizAreaId" :audoAuditorFlag="deviceRequireVoucher.audoAuditorFlag" :lowCostFlag="lowCostFlag"
                                         ref="swb_create_require_item"></swb-create-require-item>
            </template>
        </el-form>
        <div class="form-toolbar">
            <button class="swb-btn swb-btn-small swb-btn-primary" @click="goBack">返回</button>
            <button class="swb-btn swb-btn-small" v-if="showApplyBtn" @click="saveDeviceRequireVocher(true)">申请</button>
            <button class="swb-btn swb-btn-small" @click="saveDeviceRequireVocher(false)">保存</button>
        </div>
    </div>
</template>

<script>
import { Utils } from '../../app.base'
import { MsgBox, Routes, Vue } from '../../app.vues'
import { checkUserActionPerm, syncSetBreadcrumb } from '../index';
import { showComActionPostSelectDlg } from '../merchant/showSelectDlg'
import { openBizUnitOrgTreeDlg } from '../orgStruct/selectDlg'
import { getMerchtAuditBpConfInfo, openAuditTypeDlg, openDingdingAuditViewDlg, openFeiShuAuditViewDlg, openOaAuditBpNodeDlg } from '../oaAudit/selectDlg'
import { getMerchantBizParam } from '../asset/assetMain'

import userApi from '../../api/user'
import devcReqrApi from '../../api/devcReqr'
import retailerApi from '../../api/retailer'
import merchantComnApi from '../../api/merchtComn'
import oaAuditApi from '../../api/oaAudit'
import shopDevcApi from '../../api/shopDevc'

import SwbDeviceRequireVoucherManager from './DeviceRequireVoucherManager'
import SwbDeviceRequireVoucherLowCostList from './DeviceRequireVoucherLowCostList'
import SwbCreateRequireItem from './CreateRequireItem.vue'
import SwbCreateRequireItemForBatch from './CreateRequireItemForBatch'

Routes.add(SwbDeviceRequireVoucherManager);

Routes.add(SwbDeviceRequireVoucherLowCostList);

Vue.regist(SwbCreateRequireItem);

Vue.regist(SwbCreateRequireItemForBatch);

export default {
    name: 'swb-device-require-vocher-save',
    path: '/save/require/voucher',
    avlActions: '',
    avlScopes: 'retailer',
    notAsResc: true,
    authen: false,
    customBreadcrumb: true,
    desc: '保存请购单',
    data: function () {
        let validatorApplyTitle = function (rule, value, callback) {
            if(Utils.isNoB(value)) {
                callback(new Error('标题不可为空'));
            } else if(value.length > 60) {
                callback(new Error('标题最大长度60个字符(现' + value.length + '个)'));
            } else {
                callback();
            }
        };
        let validatorApplyDesc = function (rule, value, callback) {
            if(Utils.isNoB(value)) {
                callback(new Error('请填写采购需求'));
            } else if(value.length > 250) {
                callback(new Error('采购需求最大长度250个字符(现' + value.length + '个)'));
            } else {
                callback();
            }
        };
        let validatorAuditPoofNo = function (rule, value, callback) {
            if(Utils.isNoB(value)) {
                callback();
            } else if(value.length > 30) {
                callback(new Error('最大长度30个字符(现' + value.length + '个)'));
            } else {
                callback();
            }
        };
        // 验证
        return {
            isAuditBpConfAvailable: false,
            dingDingAuditFlag: false,
            feiShuAuditFlag: false,
            needAssignAuditors: false,
            deviceRequireVoucher: {
                desireArriveDate: null,
                autoApplyFlag: false,
                audoAuditorFlag: false,
                centBuyMode: false,
                desc: '', // 预算单位要对采购项目的需求应当明确，采购项目的技术规格、服务要求等等应当做采购的前期确认
                purchType: getEnumInfoWith('purchType', 'name', 'Goods').value,
                outAuditFlag: false,    // 外部审核、为：true时，将自动申请/审核请购单
                onlyForAsmblAcc: false,
            },
            bizAreaId: null,
            bizFormId: null,
            id: null,
            checkVoucher: {
                title: [{validator: validatorApplyTitle, trigger: 'blur'}],
                auditPoofNo: [{validator: validatorAuditPoofNo, trigger: 'blur'}],
                desc: [{validator: validatorApplyDesc, trigger: 'blur'}]
            },
            pickerOptions0: {
                disabledDate(time) {
                    return time.getTime() < Date.now() - 8.64e7;
                }
            },
            lowCostFlag: false,//是否选择耗材
            headComFlag: false,
            checkStateValue: null,
            parentPath: null,
            isBatchFalg: false,
            finacMgmtEnabled: false,
            needFutherAudit: false,
            usableRealComIds: [],
            dbDeviceRequireVoucher: {},
            showApplyBtn: false
        }
    },
    created: function () {
        let self = this;
        self.id = self.$route.query.id || null;
        self.lowCostFlag = Utils.isTrue(self.$route.query.lowCostFlag); // 选择耗材信息
        self.parentPath = self.$route.query.parentPath || null;
        self.isBatchFalg = Utils.isTrue(self.$route.query.isBatchFalg);
        if(!Utils.isNoB(this.id)) {
            this.getDeviceRequireVoucher(this.id);
        }
        self.showApplyBtn = checkUserActionPerm(self.parentPath, 'apply');
        let fistTitle = '资产请购';
        if(Utils.isTrue(self.lowCostFlag)) {
            fistTitle = '耗材请购';
        }
        let title = Utils.isNoB(self.id) ? '新增' : '修改';
        syncSetBreadcrumb(fistTitle + '-' + title, this.parentPath);
        //
        // 1、检查当前商户是否开启外部审批：获取已就绪的业务审批流、优先级为 seqNo。
        getMerchtAuditBpConfInfo('retailer.assets.purch', false, function (auditBpConfInfo) {
            if(!Utils.isNoB(auditBpConfInfo)) {
                self.needAssignAuditors = Utils.isTrue(auditBpConfInfo.needAssignAuditors);
                self.dingDingAuditFlag = Utils.isTrue(auditBpConfInfo.chanel == 2); // 钉钉
                self.feiShuAuditFlag = Utils.isTrue(auditBpConfInfo.chanel == 3); // 飞书
                if(!self.dingDingAuditFlag && !self.feiShuAuditFlag) {
                    // 2、如果自建的业务审批流程、检查看商户OA对接点是否就绪
                    self.isMerchtAuditBpConfAvailable();
                }
            } else {
                // 走系统内部审批
            }
        });
        getMerchantBizParam('finac.mgmt.enabled', function (result) {  // 财务管理
            self.finacMgmtEnabled = Utils.isTrue(result);
            self.getCurrentUserInfo();
            if(self.finacMgmtEnabled) {
                self.getComBizParamList();
            }
        }, 0);
        getMerchantBizParam('asset.purch.audit.by.head.com', function (result) {
            self.headComFlag = Utils.isTrue(result);
        });
        getMerchantBizParam('outer.indepent.purch.req.voucher.need.futher.audit', function (result) {
            self.needFutherAudit = Utils.isTrue(result);
        }, 0);
    },
    methods: {
        getComBizParamList() {
            let self = this;
            let postData = {
                code: 'asset.finac.enabled',
                value: 'true'
            };
            merchantComnApi.getComBizParamList(postData, function (result) {
                if(result.type == 'info') {
                    let comBizParamList = result.data;
                    if(comBizParamList.length == 0) {
                        self.usableRealComIds = [-1];
                    } else {
                        self.usableRealComIds = comBizParamList.pluck('realComId');
                    }
                } else {
                    MsgBox.warning(result.message);
                }
            })
        },
        isMerchtAuditBpConfAvailable: function () {
            let self = this;
            oaAuditApi.isMerchtAuditBpConfAvailable({bizTypeCode: 'retailer.assets.purch'}, function (result) {
                if(result.type == 'info') {
                    self.isAuditBpConfAvailable = result.data;
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        // 获取用户信息
        getCurrentUserInfo: function () {
            let self = this;
            let deviceRequireVoucher = self.deviceRequireVoucher || {};
            userApi.getUserInfoByContext({}, function (result) {
                if(result.type === 'info') {
                    let user = result.data;
                    deviceRequireVoucher.applicantName = user.scopeEntity.staffName;
                    self.deviceRequireVoucher = Utils.merge({}, deviceRequireVoucher);
                    //
                    if(Utils.isNoB(self.id)) {
                        getMerchantBizParam('asset.finac.enabled', function (normalFlagResult) {
                            let comNormalFlag = Utils.isTrue(normalFlagResult);
                            if(!self.finacMgmtEnabled || comNormalFlag) {
                                deviceRequireVoucher.requireComId = user.scopeEntity.bizUnitId;
                                deviceRequireVoucher.requireComLevel = user.scopeEntity.bizUnitOrgLevel;
                                deviceRequireVoucher.requireComName = user.scopeEntity.bizUnitName;
                                self.deviceRequireVoucher = Utils.merge({}, deviceRequireVoucher);
                                self.retailerComId(user.scopeEntity.comId);
                            } else if(self.isBatchFalg) {
                                self.retailerComId(user.scopeEntity.comId);
                            }
                        }, 2, user.scopeEntity.bizUnitId);
                    }
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        retailerComId: function (comId) {
            let self = this;
            let postData = {
                comId: comId
            };
            retailerApi.getRetailerCom(postData, function (result) {
                if(result.type == 'info') {
                    let retailerCom = result.data;
                    self.bizFormId = retailerCom.bizFormId;
                    self.bizAreaId = retailerCom.bizAreaId;
                    //
                    let deviceRequireVoucher = self.deviceRequireVoucher || {};
                    deviceRequireVoucher.requireRealComId = retailerCom.realComId;
                    deviceRequireVoucher.requireRealComName = retailerCom.realComName;
                    self.deviceRequireVoucher = Utils.merge({}, deviceRequireVoucher);
                }
            })
        },
        //
        getDeviceRequireVoucher: function (id) {
            let self = this;
            let postData = {
                id: id
            };
            let theLoad = MsgBox.loading();
            devcReqrApi.getDeviceRequireVoucherInfo(postData, function (result) {
                if(result.type === 'info') {
                    let deviceRequireVoucher = result.data;
                    if(deviceRequireVoucher != null) {
                        let goodsItemList = deviceRequireVoucher.goodsItemList;
                        let servcItemList = deviceRequireVoucher.servcItemList;
                        if(deviceRequireVoucher.goodsFlag) {
                            deviceRequireVoucher.desireArriveDate = goodsItemList[0].desireArriveDate;
                        } else {
                            if(deviceRequireVoucher.servcFlag) {
                                deviceRequireVoucher.desireArriveDate = servcItemList[0].desireArriveDate;
                            }
                        }
                        // deviceRequireVoucher.outAuditFlag = !Utils.isNoB(deviceRequireVoucher.auditPoofNo);
                    }
                    if(Utils.isNoB(deviceRequireVoucher.autoApplyFlag)) {
                        deviceRequireVoucher.autoApplyFlag = false;
                    }
                    self.deviceRequireVoucher = Utils.merge({}, deviceRequireVoucher);
                    self.dbDeviceRequireVoucher = Utils.merge({}, deviceRequireVoucher);
                    //
                    self.retailerComId(deviceRequireVoucher.requireComId);
                } else {
                    MsgBox.warning(result.message);
                }
                theLoad.hide();
            });
        },
        setCentBuyMode() {
            let centBuyMode = this.deviceRequireVoucher.centBuyMode;
            if(Utils.isTrue(centBuyMode)) {
                this.deviceRequireVoucher.audoAuditorFlag = false;
            }
        },
        //
        goBackPage: function () {
            let path = SwbDeviceRequireVoucherManager.path;
            if(Utils.isTrue(this.lowCostFlag)) {
                path = SwbDeviceRequireVoucherLowCostList.path;
            }
            this.$router.push({
                path: path,
                query: {
                    checkStateValue: this.checkStateValue
                }

            });
        },
        // 选择申请机构
        selectRequireCom: function () {
            let self = this;
            let dlgConfig = {
                enableSearch: true,
                isRadio: true,
                bizDepart: true,
                title: '申请机构-选择',
                isSelectThisLevel: true,
                usableRealComIds: self.usableRealComIds,
                optionalState: [1, 3],
                defalultState: [1]
            };
            openBizUnitOrgTreeDlg(dlgConfig, function (result, theDlg) {
                theDlg.close();
                let deviceRequireVoucher = self.deviceRequireVoucher || {};
                deviceRequireVoucher.requireComId = result.id;
                deviceRequireVoucher.requireComLevel = result.level;
                deviceRequireVoucher.requireComName = result.name;
                deviceRequireVoucher.requireBizUnitId = result.bizUnitId;
                deviceRequireVoucher.requireRealComId = result.realComId;
                deviceRequireVoucher.requireRealComName = result.realComName;
                deviceRequireVoucher.backConfirmPostId = null;
                deviceRequireVoucher.backConfirmPostName = null;
                self.deviceRequireVoucher = Utils.merge({}, deviceRequireVoucher);
                //
                self.retailerComId(result.id);
            });
        },
        //
        saveDeviceRequireVocher: function (submit) {
            if(!Utils.repeatChecker.isValidFor('saveDeviceRequireVocher', 1000)) {
                return;
            }
            if(submit) {
                if(this.isBatchFalg) {
                    let submitAvaliable = this.$refs.swb_create_require_item_for_batch.getSubmitAvaliable();
                    if(Utils.isFalse(submitAvaliable)) {
                        submit = false;
                        // MsgBox.warning('只有相同采购模式的商品才可提交，请移除不同采购模式的商品！');
                        // return;
                    }
                } else {
                    let submitAvaliable = this.$refs.swb_create_require_item.getSubmitAvaliable();
                    if(Utils.isFalse(submitAvaliable)) {
                        submit = false;
                        // MsgBox.warning('只有相同采购模式的商品才可提交，请移除不同采购模式的商品！');
                        // return;
                    }
                }
            }
            let self = this;
            self.$refs['requireVoucherRef'].validate(function (valid) {
                if(valid) {
                    let deviceRequireVoucher = self.deviceRequireVoucher || {};
                    if(Utils.isNoB(deviceRequireVoucher.requireRealComId)) {
                        Toast.show('所属公司不可为空', 3000, 'warning');
                        return;
                    }
                    if(Utils.isTrue(deviceRequireVoucher.outAuditFlag) && Utils.isNoB(deviceRequireVoucher.auditPoofNo)) {
                        Toast.show('OA审核单号不可为空', 3000, 'warning');
                        return;
                    }
                    if(Utils.isTrue(self.isBatchFalg)) {
                        if(submit) {
                            // let msg = '请购单需要手工生成给供方的订单';
                            if(deviceRequireVoucher.outAuditFlag && self.needFutherAudit == false) {
                                let msg = '请购单将生成给供方的订单';
                                MsgBox.info(msg, {
                                    callback: function () {
                                        self.checkDataForComList(submit);
                                    }
                                });
                            } else {
                                self.checkDataForComList(submit);
                            }

                        } else {
                            self.checkDataForComList(submit);
                        }
                    } else {
                        self.checkData(submit);
                    }
                } else {
                    Toast.show('校验失败', 3000, 'warning');
                    return;
                }
            });
        },
        // 单机构请购
        checkData: function (submit)  {
            let self = this;
            let servcItemList = [];
            let goodsItemList = [];
            let deviceRequireVoucher = self.deviceRequireVoucher;
            if(deviceRequireVoucher.requireComId == null) {
                Toast.show('请选择申请机构', 3000, 'warning');
                return;
            }
            //商品
            if(deviceRequireVoucher.purchType == 3 || deviceRequireVoucher.purchType == 1) {
                deviceRequireVoucher.goodsFlag = true;
                //
                let resultGoods = this.$refs.swb_create_require_item.getDlgResultGoods() || {};
                if(resultGoods.type == 'info') {
                    goodsItemList = resultGoods['goodsItemList'] || [];
                    if(goodsItemList.length < 1) {
                        Toast.show('请填写请购商品', 3000, 'warning');
                        return;
                    }
                } else {
                    Toast.show(resultGoods.message, 3000, 'warning');
                    return;
                }
            } else {
                deviceRequireVoucher.goodsItemList = [];
                deviceRequireVoucher.goodsFlag = false;
            }
            //服务
            if(deviceRequireVoucher.purchType == 3 || deviceRequireVoucher.purchType == 2) {
                deviceRequireVoucher.servcFlag = true;
                //
                let resultServc = this.$refs.swb_create_require_item.getDlgResultService() || {};
                if(resultServc.type == 'info') {
                    servcItemList = resultServc['servcItemList'] || [];
                    if(servcItemList.length < 1) {
                        Toast.show('请填写请购服务', 3000, 'warning');
                        return;
                    }
                } else {
                    Toast.show(resultServc.message, 3000, 'warning');
                    return;
                }
            } else {
                deviceRequireVoucher.servcItemList = [];
                deviceRequireVoucher.servcFlag = false;
            }
            if(Utils.isFalse(deviceRequireVoucher.servcFlag) && Utils.isFalse(deviceRequireVoucher.goodsFlag)) {
                MsgBox.warning('请选择对应对的商品或服务');
                return false;
            }
            let desireArriveDate = deviceRequireVoucher.desireArriveDate;
            let desireArriveDateTemp = null;
            if(desireArriveDate != null) {
                desireArriveDateTemp = desireArriveDate.format('yyyy-MM-dd');
            }
            //
            if(goodsItemList.length > 0) {
                for(let i = 0; i < goodsItemList.length; i++) {
                    let item = goodsItemList[i];
                    item.desireArriveDate = desireArriveDateTemp;
                }
                deviceRequireVoucher.goodsItemList = goodsItemList;
            }
            //
            if(servcItemList.length > 0) {
                for(let i = 0; i < servcItemList.length; i++) {
                    let item = servcItemList[i];
                    item.desireArriveDate = desireArriveDateTemp;
                }
                deviceRequireVoucher.servcItemList = servcItemList;
            }
            // 附件信息
            let deviceRequireFileList = this.$refs.swb_create_require_item.getDlgResultFiles() || [];
            deviceRequireVoucher.deviceRequireFileList = Utils.merge([], deviceRequireFileList);
            //
            deviceRequireVoucher.stuffFlag = Utils.isTrue(self.lowCostFlag) ? self.lowCostFlag : false;
            if(submit) {
                if(self.dingDingAuditFlag) {    // 钉钉
                    let self = this;
                    openAuditTypeDlg(null, function (auditType, theDlg) {
                        theDlg.close();
                        let dingDingFlag = Utils.isTrue(auditType);
                        if(dingDingFlag) {
                            let submitRequireVoucher = {
                                deviceRequireVoucher: deviceRequireVoucher,
                            };
                            //
                            let params = {
                                bizVoucherId: deviceRequireVoucher.id,
                                bizVoucherNo: deviceRequireVoucher.innerNo,
                                bizTypeCode: 'retailer.assets.purch',
                            };
                            openDingdingAuditViewDlg(params, function (resultData) {
                                let departId = resultData.departId;
                                // 返回值：departId（部门ID）
                                submitRequireVoucher.departId = departId || null;
                                submitRequireVoucher.dingdingFlag = dingDingFlag;
                                //
                                self.doSubmitDeviceRequireVoucher(submitRequireVoucher);
                                //
                                // self.doApplyForOaAudit(deviceRequireVoucher, [], null, departId);
                            }, function (theDlg) {
                                theDlg.close();
                            });
                        } else {
                            // 获取最近一次审核人信息
                            self.toInnerApplyDeviceRequirevoucherSigle(deviceRequireVoucher);
                        }
                    });
                } else if(self.feiShuAuditFlag) {
                    let self = this;
                    // openAuditTypeDlg('feishu', function (auditType, theDlg) {
                    //     theDlg.close();
                    //     let feiShuFlag = Utils.isTrue(auditType);
                    //     if(feiShuFlag) {
                    //         let submitRequireVoucher = {
                    //             deviceRequireVoucher: deviceRequireVoucher,
                    //         };
                    //         let params = {
                    //             bizVoucherId: deviceRequireVoucher.id,
                    //             bizVoucherNo: deviceRequireVoucher.innerNo,
                    //             bizTypeCode: 'retailer.assets.purch',
                    //         };
                    //         openFeiShuAuditViewDlg(params, function (resultData) {
                    //             let departId = resultData.departId;
                    //             // 返回值：departId（部门ID）
                    //             submitRequireVoucher.feiShuDepartId = departId || null;
                    //             submitRequireVoucher.feiShuFlag = feiShuFlag;
                    //             //
                    //             self.doSubmitDeviceRequireVoucher(submitRequireVoucher);
                    //         }, function (theDlg) {
                    //             theDlg.close();
                    //         });
                    //     } else {
                    //         // 获取最近一次审核人信息
                    //         self.toInnerApplyDeviceRequirevoucherSigle(deviceRequireVoucher);
                    //     }
                    // });
                    let submitRequireVoucher = {
                        deviceRequireVoucher: deviceRequireVoucher
                    };
                    let params = {
                        bizVoucherId: deviceRequireVoucher.id,
                        bizVoucherNo: deviceRequireVoucher.innerNo,
                        bizTypeCode: 'retailer.assets.purch',
                    };
                    openFeiShuAuditViewDlg(params, function (resultData) {
                        let departId = resultData.departId;
                        let decisionBasisVal = resultData.decisionBasisVal;
                        let bizScenario = resultData.bizScenario;
                        // 返回值：departId（部门ID）
                        submitRequireVoucher.feiShuDepartId = departId || null;
                        submitRequireVoucher.decisionBasisVal = decisionBasisVal || null;
                        submitRequireVoucher.feiShuFlag = true;
                        submitRequireVoucher.bizScenario = bizScenario || null;
                        //
                        self.doSubmitDeviceRequireVoucher(submitRequireVoucher);
                    }, function (theDlg) {
                        theDlg.close();
                    });
                } else {
                    if(this.isAuditBpConfAvailable) {
                        let submitRequireVoucher = {
                            deviceRequireVoucher: deviceRequireVoucher,
                        };
                        if(self.needAssignAuditors) {    // 打开审批人员
                            let params = {
                                bizTypeCode: 'retailer.assets.purch',
                                bizVoucherNo: deviceRequireVoucher.innerNo || deviceRequireVoucher.no,
                                auditSeqNo: deviceRequireVoucher.auditSeqNo
                            };
                            openOaAuditBpNodeDlg(params, function (auditorList, theDlg) {
                                theDlg.close();
                                auditorList = auditorList || [];
                                if(auditorList.length <= 0) {
                                    MsgBox.warning('无审批人员信息');
                                    return;
                                }
                                submitRequireVoucher.auditorList = Utils.merge([], auditorList);
                                //
                                self.doSubmitDeviceRequireVoucher(submitRequireVoucher);
                                //
                                // self.doApplyForOaAudit(deviceRequireVoucher, auditorList, theDlg);
                            }, function (cancleFlag, theDlg) {
                                theDlg.close();
                            });
                        } else {
                            submitRequireVoucher.auditorList = [];
                            self.doSubmitDeviceRequireVoucher(submitRequireVoucher);
                        }
                    } else {
                        // 获取最近一次审核人信息
                        self.toInnerApplyDeviceRequirevoucherSigle(deviceRequireVoucher);
                    }
                }
            } else {
                deviceRequireVoucher.submitFlag = false;
                let lastMsgBoxDlg = MsgBox.loading();
                devcReqrApi.saveDeviceRequireVoucher(deviceRequireVoucher, function (result) {
                    lastMsgBoxDlg.close();
                    if(result.type === 'info') {
                        // 根据返回的单据ID 判断后台是否根据集采自采拆单，拆单的直接返回单据列表
                        if(Utils.isNoB(result.data) || Utils.isNoB(result.data.id)) {
                            let callback = function () {
                                self.checkStateValue = 'Applied';
                                self.goBackPage();
                            };
                            MsgBox.success('保存成功', {callback: callback});
                        } else {
                            MsgBox.success('保存成功');
                            //
                            self.getDeviceRequireVoucher(result.data.id);
                            self.id = result.data.id;
                            self.reloadItem = !self.reloadItem;
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            }
        },
        // 保存并申请接口
        doSubmitDeviceRequireVoucher: function (submitRequireVoucher) {
            let self = this;
            let theLoadX = MsgBox.loading();
            devcReqrApi.doSubmitDeviceRequireVoucher(submitRequireVoucher, function (resultX) {
                if(resultX.type == 'info') {
                    let callback = function () {
                        self.checkStateValue = 'Applied';
                        self.goBackPage();
                        //
                        if(!self.needAssignAuditors) {
                            let auditBpStateInfo = resultX.data || {};
                            if(Utils.isTrue(auditBpStateInfo.outerAuditFlag) && !Utils.isTrue(auditBpStateInfo.bpStarted) && auditBpStateInfo.auditState == 0) {
                                let params = {
                                    no: auditBpStateInfo.voucherNo
                                };
                                self.openOuterBpStartWin(params);
                            }
                        }
                    };
                    MsgBox.success('申请成功', {callback: callback});
                } else {
                    // 申请失败时，保证不会出现重复单据，再次提交视为修改
                    let auditBpStateInfo = resultX.data || {};
                    if(!Utils.isNoB(auditBpStateInfo.requireVoucher) && !Utils.isNoB(auditBpStateInfo.requireVoucher.id)) {
                        let deviceRequireVoucher = self.deviceRequireVoucher;
                        deviceRequireVoucher.id = auditBpStateInfo.requireVoucher.id;
                        //
                        self.deviceRequireVoucher = Utils.merge({}, deviceRequireVoucher);
                    }
                    //
                    MsgBox.failure(resultX.message);
                }
                theLoadX.hide();
            });
        },
        // 打开审批申请页面
        openOuterBpStartWin: function (row) {
            let bizVoucherNo = row.no;
            if(!Utils.isNoB(row.innerNo)) {
                bizVoucherNo = row.innerNo;
            }
            let params = {};
            params.bizTypeCode = 'retailer.assets.purch';
            params.bizVoucherNo = bizVoucherNo;
            params.auditSeqNo = row.auditSeqNo;
            oaAuditApi.getBpStartPageUrl(params, function (result) {
                if(result.type === 'info') {
                    let pageUrl = result.data;
                    Utils.openWindow(pageUrl);
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        // 多机构请购
        checkDataForComList: function (submit) {
            let self = this;
            let deviceRequireVoucher = self.deviceRequireVoucher || {};
            let result = this.$refs.swb_create_require_item_for_batch.getDlgResultMerchantComList() || {};
            if(result.type == 'info') {
                let resultData = result.data || {};
                let merchantComList = resultData.merchantComList || [];
                let deviceRequireFileList = resultData.deviceRequireFileList || [];
                //
                for(let i = 0; i < merchantComList.length; i++) {
                    let merchantCom = merchantComList[i];
                    //
                    let desireArriveDate = deviceRequireVoucher.desireArriveDate || null;
                    let desireArriveDateTemp = null;
                    if(!Utils.isNoB(desireArriveDate)) {
                        desireArriveDateTemp = desireArriveDate.format('yyyy-MM-dd');
                    }
                    let goodsItemList = merchantCom.goodsItemList || [];
                    if(goodsItemList.length > 0) {
                        for(let j = 0; j < goodsItemList.length; j++) {
                            let item = goodsItemList[j];
                            item.desireArriveDate = desireArriveDateTemp;
                        }
                        merchantCom.goodsItemList = goodsItemList;
                    }
                    let servcItemList = merchantCom.servcItemList || [];
                    if(servcItemList.length > 0) {
                        for(let j = 0; j < servcItemList.length; j++) {
                            let item = servcItemList[j];
                            item.desireArriveDate = desireArriveDateTemp;
                        }
                        merchantCom.servcItemList = servcItemList;
                    }
                    // 转换id
                    merchantCom.comId = merchantCom.id;
                    merchantCom.comName = merchantCom.name;
                }
                deviceRequireVoucher.deviceRequireFileList = Utils.merge([], deviceRequireFileList);
                deviceRequireVoucher.deviceRequireItemDtoList = Utils.merge([], merchantComList);
            } else {
                Toast.show(result.message, 3000, 'warning');
                return;
            }
            deviceRequireVoucher.stuffFlag = Utils.isTrue(self.lowCostFlag) ? self.lowCostFlag : false;
            if(submit) {
                if(deviceRequireVoucher.outAuditFlag) {
                    if(self.needFutherAudit == false) {
                        deviceRequireVoucher.submitFlag = true; //自动申请、审核
                        let lastMsgBoxDlg = MsgBox.loading();
                        devcReqrApi.saveDeviceRequireVoucherForBatch(deviceRequireVoucher, function (result) {
                            lastMsgBoxDlg.close();
                            if(result.type === 'info') {
                                let callback = function () {
                                    self.checkStateValue = 'Initial';
                                    self.goBackPage();
                                };
                                MsgBox.success('保存成功', {callback: callback});
                            } else {
                                MsgBox.warning(result.message);
                            }
                        });
                    } else {
                        // 内部审批
                        self.toInnerApplyDeviceRequireVoucher(deviceRequireVoucher);
                    }
                } else if(self.dingDingAuditFlag) {    // 钉钉
                    let self = this;
                    openAuditTypeDlg(null, function (auditType, theDlg) {
                        theDlg.close();
                        let dingDingFlag = Utils.isTrue(auditType);
                        if(dingDingFlag) {
                            let submitRequireVoucher = {
                                deviceRequireVoucher: deviceRequireVoucher,
                            };
                            //
                            let params = {
                                bizVoucherId: deviceRequireVoucher.id,
                                bizVoucherNo: deviceRequireVoucher.innerNo,
                                bizTypeCode: 'retailer.assets.purch',
                            };
                            openDingdingAuditViewDlg(params, function (resultData) {
                                let departId = resultData.departId;
                                // 返回值：departId（部门ID）
                                submitRequireVoucher.departId = departId || null;
                                submitRequireVoucher.dingdingFlag = dingDingFlag;
                                submitRequireVoucher.voucherBatchFlag = true;   // 多机构请购
                                //
                                self.doSubmitDeviceRequireVoucher(submitRequireVoucher);
                                //
                                // self.doApplyForOaAudit(deviceRequireVoucher, [], null, departId);
                            }, function (theDlg) {
                                theDlg.close();
                            });
                        } else {
                            // 获取最近一次审核人信息
                            self.toInnerApplyDeviceRequirevoucherSigle(deviceRequireVoucher);
                        }
                    });
                } else if(self.feiShuAuditFlag) {
                    let self = this;
                    // openAuditTypeDlg('feishu', function (auditType, theDlg) {
                    //     theDlg.close();
                    //     let feiShuFlag = Utils.isTrue(auditType);
                    //     if(feiShuFlag) {
                    //         let submitRequireVoucher = {
                    //             deviceRequireVoucher: deviceRequireVoucher,
                    //         };
                    //         let params = {
                    //             bizVoucherId: deviceRequireVoucher.id,
                    //             bizVoucherNo: deviceRequireVoucher.innerNo,
                    //             bizTypeCode: 'retailer.assets.purch',
                    //         };
                    //         openFeiShuAuditViewDlg(params, function (resultData) {
                    //             let departId = resultData.departId;
                    //             // 返回值：departId（部门ID）
                    //             submitRequireVoucher.feiShuDepartId = departId || null;
                    //             submitRequireVoucher.feiShuFlag = feiShuFlag;
                    //             //
                    //             self.doSubmitDeviceRequireVoucher(submitRequireVoucher);
                    //         }, function (theDlg) {
                    //             theDlg.close();
                    //         });
                    //     } else {
                    //         // 获取最近一次审核人信息
                    //         self.toInnerApplyDeviceRequirevoucherSigle(deviceRequireVoucher);
                    //     }
                    // });
                    let submitRequireVoucher = {
                        deviceRequireVoucher: deviceRequireVoucher
                    };
                    let params = {
                        bizVoucherId: deviceRequireVoucher.id,
                        bizVoucherNo: deviceRequireVoucher.innerNo,
                        bizTypeCode: 'retailer.assets.purch',
                    };
                    openFeiShuAuditViewDlg(params, function (resultData) {
                        let departId = resultData.departId;
                        let decisionBasisVal = resultData.decisionBasisVal;
                        let bizScenario = resultData.bizScenario;
                        // 返回值：departId（部门ID）
                        submitRequireVoucher.feiShuDepartId = departId || null;
                        submitRequireVoucher.decisionBasisVal = decisionBasisVal || null;
                        submitRequireVoucher.feiShuFlag = true;
                        submitRequireVoucher.bizScenario = bizScenario || null;
                        submitRequireVoucher.voucherBatchFlag = true;   // 多机构请购
                        //
                        self.doSubmitDeviceRequireVoucher(submitRequireVoucher);
                    }, function (theDlg) {
                        theDlg.close();
                    });
                } else {
                    if(this.isAuditBpConfAvailable) {  // OA审批
                        let submitRequireVoucher = {
                            deviceRequireVoucher: deviceRequireVoucher
                        };
                        if(self.needAssignAuditors) {  // 打开审批人员
                            let params = {
                                bizTypeCode: 'retailer.assets.purch',
                                bizVoucherNo: deviceRequireVoucher.innerNo || deviceRequireVoucher.no,
                                auditSeqNo: deviceRequireVoucher.auditSeqNo
                            };
                            openOaAuditBpNodeDlg(params, function (auditorList, theDlg) {
                                theDlg.close();
                                auditorList = auditorList || [];
                                if(auditorList.length <= 0) {
                                    MsgBox.warning('无审批人员信息');
                                    return;
                                }
                                submitRequireVoucher.auditorList = Utils.merge([], auditorList);
                                submitRequireVoucher.voucherBatchFlag = true;   // 多机构请购
                                //
                                self.doSubmitDeviceRequireVoucher(submitRequireVoucher);
                                //
                                // self.doApplyForOaAudit(deviceRequireVoucher, auditorList, theDlg);
                            }, function (cancleFlag, theDlg) {
                                theDlg.close();
                            });
                        }
                    } else {
                        // 内部审批
                        self.toInnerApplyDeviceRequireVoucher(deviceRequireVoucher);
                    }
                }
            } else {
                deviceRequireVoucher.submitFlag = false;
                let lastMsgBoxDlg = MsgBox.loading();
                devcReqrApi.saveDeviceRequireVoucherForBatch(deviceRequireVoucher, function (result) {
                    lastMsgBoxDlg.close();
                    if(result.type === 'info') {
                        // 返回当前创建的ID , 如果为空则认为 集采和自采同时存在，按照集采自采拆单。直接返列表
                        if(Utils.isNoB(result.data)) {
                            let callback = function () {
                                self.checkStateValue = 'Applied';
                                self.goBackPage();
                            };
                            MsgBox.success('保存成功', {callback: callback});
                        } else {
                            MsgBox.success('保存成功');
                            self.getDeviceRequireVoucher(result.data);
                            self.id = result.data;
                            self.reloadItem = !self.reloadItem;
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            }
        },
        // 内部审批-多机构
        toInnerApplyDeviceRequireVoucher: function (deviceRequireVoucher) {
            let self = this;
            let params = {
                bizUnitId: deviceRequireVoucher.requireBizUnitId,
                voucherType: getEnumInfoWith('devcVoucherType', 'name', 'Receiving').value
            };
            let theLoad = MsgBox.loading();
            shopDevcApi.getLastAuditInfo(params, function (resultX) {
                theLoad.hide();
                if(resultX.type == 'info') {
                    let auditInfo = resultX.data;
                    let initPostId = null;
                    let auditorStaffId = deviceRequireVoucher.auditorStaffId;
                    let auditorName = deviceRequireVoucher.auditorName;
                    if(!Utils.isNoB(auditInfo) && auditInfo.postId > 0) {
                        initPostId = auditInfo.postId;
                        auditorStaffId = auditInfo.staffId;
                        auditorName = auditInfo.staffName;
                    }
                    //
                    showComActionPostSelectDlg({
                        rescUrl: SwbDeviceRequireVoucherManager.path,
                        action: 'audit',
                        useParent: true,
                        expandedParents: true,
                        headComFlag: self.headComFlag,
                        initPostId: initPostId,
                        showAuditor: !Utils.isNoB(auditorStaffId),
                        showAuditStaff: true,
                        auditorStaffId: auditorStaffId,
                        auditorName: auditorName
                    }, function (resultData) {
                        resultData = resultData || {};
                        if(resultData.postId == null) {
                            Toast.show('请选 择审核岗位', 3000, 'warning');
                            return false;
                        }
                        //
                        deviceRequireVoucher.auditorPostId = resultData.postId;
                        deviceRequireVoucher.appliedComLevel = resultData.comLevel;
                        deviceRequireVoucher.auditorStaffId = resultData.auditorStaffId;
                        deviceRequireVoucher.auditorName = resultData.auditorName;
                        deviceRequireVoucher.applyDesc = resultData.applyDesc;
                        deviceRequireVoucher.submitFlag = true;
                        //
                        let theLoad = MsgBox.loading();
                        devcReqrApi.saveDeviceRequireVoucherForBatch(deviceRequireVoucher, function (result) {
                            theLoad.close();
                            if(result.type === 'info') {
                                let callback = function () {
                                    self.checkStateValue = 'Applied';
                                    self.goBackPage();
                                };
                                MsgBox.success('提交成功', {callback: callback});
                            } else {
                                MsgBox.warning(result.message);
                            }
                        });
                    }, this);
                } else {
                    MsgBox.warning(resultX.message);
                }
            });
        },
        // 内部审批-单机构
        toInnerApplyDeviceRequirevoucherSigle: function (deviceRequireVoucher) {
            let self = this;
            let params = {
                bizUnitId: deviceRequireVoucher.requireBizUnitId,
                voucherType: getEnumInfoWith('devcVoucherType', 'name', 'Receiving').value
            };
            let theLoad = MsgBox.loading();
            shopDevcApi.getLastAuditInfo(params, function (resultX) {
                theLoad.hide();
                if(resultX.type == 'info') {
                    let auditInfo = resultX.data;
                    let initPostId = null;
                    let auditorStaffId = deviceRequireVoucher.auditorStaffId;
                    let auditorName = deviceRequireVoucher.auditorName;
                    if(!Utils.isNoB(auditInfo) && auditInfo.postId > 0) {
                        initPostId = auditInfo.postId;
                        auditorStaffId = auditInfo.staffId;
                        auditorName = auditInfo.staffName;
                    }
                    // 非外部审批的提交需要选择审核岗
                    showComActionPostSelectDlg({
                        rescUrl: SwbDeviceRequireVoucherManager.path,
                        action: 'audit',
                        useParent: true,
                        expandedParents: true,
                        headComFlag: self.headComFlag,
                        initPostId: initPostId,
                        showAuditor: !Utils.isNoB(auditorStaffId),
                        showAuditStaff: true,
                        auditorStaffId: auditorStaffId,
                        auditorName: auditorName
                    }, function (resultData) {
                        resultData = resultData || {};
                        if(resultData.postId == null) {
                            Toast.show('请选 择审核岗位', 3000, 'warning');
                            return false;
                        }
                        //
                        deviceRequireVoucher.auditorPostId = resultData.postId;
                        deviceRequireVoucher.appliedComLevel = resultData.comLevel;
                        deviceRequireVoucher.auditorStaffId = resultData.auditorStaffId;
                        deviceRequireVoucher.auditorName = resultData.auditorName;
                        deviceRequireVoucher.applyDesc = resultData.applyDesc;
                        deviceRequireVoucher.submitFlag = true;
                        //
                        let theLoad = MsgBox.loading();
                        devcReqrApi.saveDeviceRequireVoucher(deviceRequireVoucher, function (result) {
                            theLoad.close();
                            if(result.type === 'info') {
                                let callback = function () {
                                    self.checkStateValue = 'Applied';
                                    self.goBackPage();
                                };
                                MsgBox.success('提交成功', {callback: callback});
                            } else {
                                MsgBox.warning(result.message);
                            }
                        });
                    }, this);
                } else {
                    MsgBox.warning(resultX.message);
                }
            });
        },
        goBack() {
            let self = this;
            let dbDeviceRequireVoucher = Utils.merge({}, self.dbDeviceRequireVoucher);
            let dbGoodsItemList = Utils.merge([], dbDeviceRequireVoucher.goodsItemList) || [];
            let dbServcItemList = Utils.merge([], dbDeviceRequireVoucher.servcItemList) || [];
            let dbDeviceRequireFileList = Utils.merge([], dbDeviceRequireVoucher.deviceRequireFileList) || [];
            dbDeviceRequireVoucher.goodsItemList = [];
            dbDeviceRequireVoucher.servcItemList = [];
            dbDeviceRequireVoucher.deviceRequireFileList = [];
            let deviceRequireVoucher = Utils.merge({}, self.deviceRequireVoucher);
            deviceRequireVoucher.goodsItemList = [];
            deviceRequireVoucher.servcItemList = [];
            deviceRequireVoucher.deviceRequireFileList = [];
            deviceRequireVoucher.stuffFlag = Utils.isTrue(self.lowCostFlag) ? self.lowCostFlag : false;
            if(Utils.isTrue(self.isBatchFalg)) {
                let result = this.$refs.swb_create_require_item_for_batch.getDlgResultMerchantComList() || {};
                let resultData = result.data || {};
                let merchantComList = resultData.merchantComList || [];
                let deviceRequireFileList = resultData.deviceRequireFileList || [];
                //
                let goodsItemList = [];
                let servcItemList = [];
                for(let i = 0; i < merchantComList.length; i++) {
                    let merchantCom = merchantComList[i];
                    goodsItemList = goodsItemList.concat(merchantCom.goodsItemList || []);
                    servcItemList = servcItemList.concat(merchantCom.servcItemList || []);
                }
                //
                if(!Utils.isNoB(deviceRequireVoucher.id) && (!Utils.obj_val_equal(dbDeviceRequireVoucher, deviceRequireVoucher, true, ['goodsFlag', 'servcFlag', 'ts']) ||
                    !Utils.obj_val_equal(dbGoodsItemList, goodsItemList, true, ['desireArriveDate', 'reqCentBuyMode', 'ts']) ||
                    !Utils.obj_val_equal(dbServcItemList, servcItemList, true, ['ts']) ||
                    !Utils.obj_val_equal(dbDeviceRequireFileList, deviceRequireFileList, true, [])
                )) {
                    this.$confirm('存在未保存内容，是否确定关闭当前页面?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(function () {
                        self.$router.back(-1);
                    }).catch(function () {
                    });
                } else {
                    self.$router.back(-1);
                }
            } else {
                let resultGoods = this.$refs.swb_create_require_item.getDlgResultGoods() || {};
                let goodsItemList = resultGoods['goodsItemList'] || [];
                let resultServc = this.$refs.swb_create_require_item.getDlgResultService() || {};
                let servcItemList = resultServc['servcItemList'] || [];
                let deviceRequireFileList = this.$refs.swb_create_require_item.getDlgResultFiles() || [];
                //
                if(!Utils.isNoB(deviceRequireVoucher.id) && (!Utils.obj_val_equal(dbDeviceRequireVoucher, deviceRequireVoucher, true, ['goodsFlag', 'servcFlag', 'ts']) ||
                    !Utils.obj_val_equal(dbGoodsItemList, goodsItemList, true, ['desireArriveDate', 'reqCentBuyMode', 'ts']) ||
                    !Utils.obj_val_equal(dbServcItemList, servcItemList, true, ['ts']) ||
                    !Utils.obj_val_equal(dbDeviceRequireFileList, deviceRequireFileList, true, [])
                )) {
                    this.$confirm('存在未保存内容，是否确定关闭当前页面?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(function () {
                        self.$router.back(-1);
                    }).catch(function () {
                    });
                } else {
                    self.$router.back(-1);
                }
            }
        }
    }
}

</script>



// WEBPACK FOOTER //
// src/compo/retailer/DeviceRequireVocherSave.vue